import {AfterViewInit, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {MxCustomizable} from '../../../../mx-customizer';
import {MxPreviousRouteService} from '../../../../shared/services/mx-previous-route.service';
import {MxFormCustomizerEvent} from '../../services/mx-form-fields-builder.service';

@Component({
    selector: 'mx-object-form-dialog',
    standalone: false,
    styleUrls: ['./mx-object-form-dialog.component.scss'],
    template: `<ng-template #formTemplate>
        <mx-object-form (customize)="onCustomize($event)" (formClose)="onFormClosed($event)"></mx-object-form>
    </ng-template>`
})

export class MxObjectFormDialogComponent implements AfterViewInit, MxCustomizable<MxFormCustomizerEvent> {
    @Output() customize: EventEmitter<MxFormCustomizerEvent> = new EventEmitter<MxFormCustomizerEvent>();

    @Input()
    private panelClass: string;

    @ViewChild('formTemplate', {static: true})
    private formTemplate: TemplateRef<any>;

    confirmCloseFn: () => boolean | Observable<boolean> | Promise<boolean>;
    private dialogRef: MatDialogRef<TemplateRef<any>>;
    private confirmClose: boolean = this.route.snapshot.data.closeConfirmation;

    constructor (private dialog: MatDialog,
                 private route: ActivatedRoute,
                 private previousRouteService: MxPreviousRouteService) {
    }

    onCustomize(e: MxFormCustomizerEvent): void {
        e.customizeProps({showNavigation: false, navigateBackOnCancel: false});
        this.confirmCloseFn = e.closeConfirmationFunction;
        this.customize.emit(e);
    }

    ngAfterViewInit (): void {
        let config: MatDialogConfig = {
            minWidth: '50%',
            disableClose: true,
            panelClass: ['mx-object-form-panel-class']
        };

        if (this.panelClass) {
            (<string[]> config.panelClass).push(this.panelClass);
        }

        this.dialogRef = this.dialog.open(this.formTemplate, config);
        this.dialogRef.backdropClick()
            .subscribe(_ => {
                this.closeConfirmationCheck();
        });
    }

    onFormClosed(closeParam: {submit: boolean, back: boolean, response: boolean }): void {
        // This event handler is triggered whenever 'Ok' or 'Cancel' button is clicked in BoObjectForm.
        // Here we set result to false to let this.dialogRef.afterClosed() handler know, that navigatePreviousPage() was
        // already done.
        if (!closeParam.submit) {
            this.closeConfirmationCheck();
        } else {
            this.dialogRef.close(false);
        }
    }

    private closeConfirmationCheck(): void {
        let navigateParent = this.previousRouteService.navigateToParentFunc(this.route, this.route.snapshot.data.navigateParent === true);
        if (this.confirmClose === true && this.confirmCloseFn) {
            (<Observable<boolean>>this.confirmCloseFn()).subscribe(value => {
                if (value) {
                    navigateParent();
                    this.dialogRef.close(false);
                }
            });
        } else {
            navigateParent();
            this.dialogRef.close(false);
        }
    }
}
